module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/BW/football-5f9f952f8987865f9e809bc358c2d78c.svg";